String.prototype.toUpFirstLetter = function () {
    if (!this) return '';
    return this.charAt(0).toUpperCase() + this.substr(1);
};